import React, { useState } from "react";
import LogoFull from "assets/logo-full.png";
//@ts-ignore
import LoginBG from "assets/login-bg.mp4";
import ReactModal from "react-modal";

function LoginScreen() {
  const [showLaugh, setShowLaugh] = useState(false);

  return (
    <div className="flex flex-row h-screen w-screen relative">
      <ReactModal
        isOpen={showLaugh}
        contentLabel="onRequestClose Example"
        onRequestClose={() => setShowLaugh(false)}
        shouldCloseOnOverlayClick
        style={{
          content: {
            width: "600px",
            height: "600px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        }}
      >
        <iframe
          title="laugh"
          src="https://giphy.com/embed/3oEjHI8WJv4x6UPDB6"
          width="100%"
          height="550"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </ReactModal>
      <div className="flex w-full md:w-1/2 bg-white h-screen absolute left-0 justify-center items-center">
        <img
          alt="logo"
          src={LogoFull}
          className="w-[200px] h-[150px] absolute top-0 left-10 object-contain"
        />
        <div className="w-80">
          <p className="font-exo text-center text-lg">Welcome.</p>
          <div className="mt-14">
            <p className="font-semibold font-exo text-sm mb-3">Email</p>
            <input
              type={"email"}
              placeholder="Email"
              className="rounded-md w-full h-8 font-montserrat text-sm px-2 border border-slate-400"
            />
          </div>
          <div className="mt-3">
            <p className="font-semibold font-exo text-sm mb-3">Password</p>
            <input
              type={"password"}
              placeholder="Password"
              className="rounded-md w-full h-8 font-montserrat text-sm px-2 border border-slate-400"
            />
          </div>
          <button className="mt-6 bg-gray-800 text-white font-exo text-md w-full h-8 rounded-sm hover:bg-gray-700 focus:bg-gray-500">
            Login
          </button>
          <p className="font-montserrat text-sm text-center mt-6 text-gray-800">
            Don't have an account?{" "}
            <span
              onClick={() => setShowLaugh(true)}
              className="underline hover:cursor-pointer hover:text-gray-500"
            >
              Well, poor you.
            </span>
          </p>
        </div>
      </div>
      <video
        autoPlay
        loop
        muted
        className="hidden md:block w-1/2 h-full object-cover absolute right-0 shadow-2xl"
      >
        <source src={LoginBG} type="video/mp4" />
      </video>
    </div>
  );
}

export default LoginScreen;
